module.exports = __webpack_public_path__ + "static/get-started-1.93d53314.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/get-started-1.svg
// module id = 105
// module chunks = 31532440822795 87034247430840 214286880276331